module.exports = __webpack_public_path__ + "img/caret-up-1.15b5f8ee.png";